import React, { Component } from "react";
import { Table, Button } from "antd";
import { RightOutlined } from "@ant-design/icons";
import moment from "moment";
import debounce from "lodash/debounce";
import { connect } from "react-redux";

import { apiCustomerPR } from "../../../../api/api-customer-payment-request";
import { PaymentRequestDetail } from "./payment-request-detail";
import { emitter } from "../../../../common/utils/emitter";
import { alert } from "../../../../common/utils/alert";

class CustomerPaymentRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      total: 0,
      isShowDetail: false,
    };

    this.page = 1;

    this.customerTable = [
      {
        title: "Hợp đồng",
        dataIndex: "contract_code",
        key: "contract_code",
      },
      {
        title: "Thời gian hành trình",
        dataIndex: "data",
        key: "data",
        render: (data) => {
          const start = moment(data.from_date).format("DD/MM/YYYY");
          const end = moment(data.to_date).format("DD/MM/YYYY");
          return data ? (
            <span>
              {start} - {end}
            </span>
          ) : null;
        },
      },
      {
        title: "Tài xế",
        dataIndex: "driver_name",
        key: "driver_name",
      },
      {
        title: "Biển KS",
        dataIndex: "vehicle_number_plate",
        key: "vehicle_number_plate",
      },
      {
        title: "Thời gian gửi",
        dataIndex: "created_at",
        key: "created_at",
        render: (item) => {
          const time_unix = moment(item).format("DD/MM/YYYY");
          return item ? <span>{time_unix}</span> : null;
        },
      },
      {
        title: "Chi tiết",
        dataIndex: "data",
        key: "detail",
        render: (data) => (
          <div style={{ minWidth: 60 }} onClick={() => this.showDetail(data)}>
            <img
              alt=""
              className="detail-icon"
              src={require("../../../../assets/icons/info-circle-solid.png")}
            />
          </div>
        ),
      },
    ];
  }

  componentDidMount() {
    this.getData(1);
  }

  showDetail = (data) => {
    this.setState(
      {
        isShowDetail: true,
      },
      () => {
        this.prDetail.showDetailPR(data);
      }
    );
  };

  handleShowDetail = (status, data) => {
    this.setState(
      {
        isShowDetail: status,
        dataChoose: data,
      },
      () => {
        const element = document.getElementById("right-layout");
        element.scrollTo(0, 0);
        if (!status) {
          this.getData(1);
        }
      }
    );
  };

  getData = async (page) => {
    if (page) {
      this.page = page;
    } else {
      this.page = 1;
    }
    try {
      emitter.emit("FETCH_LOADING", true);
      const result = await apiCustomerPR.getPaymentRequest(page);
      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        const dataConvert = result.data.content.map((value, index) => {
          return {
            index: index + (page - 1) * 10 + 1,
            ...value,
            data: value,
          };
        });
        this.setState(
          { dataTable: dataConvert, total: result.data.total_elements },
          () => {}
        );
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  onChangePage = (page) => {
    const element = document.getElementById("right-layout");
    element.scrollTo(0, 0);
    this.getData(page);
  };

  render() {
    const { dataTable, total, isShowDetail } = this.state;
    return (
      <div className="customer-payment-request">
        <div className="title">
          <span onClick={() => this.handleShowDetail(false)}>
            Danh sách Payment Request
          </span>
          {isShowDetail && (
            <>
              <RightOutlined />
              <span> Chi tiết Payment Request</span>
            </>
          )}
        </div>
        {isShowDetail && (
          <PaymentRequestDetail
            auth={this.props.auth}
            ref={(ref) => (this.prDetail = ref)}
          />
        )}

        {!isShowDetail && (
          <>
            <Table
              className="customer-pr-table"
              rowKey={(record) => record.id}
              style={{ width: "100%" }}
              dataSource={dataTable}
              pagination={{
                total,
                pageSize: 10,
                onChange: this.onChangePage,
                current: this.page,
              }}
              //pagination={false}
              scroll={{ x: true }}
              bordered
              columns={this.customerTable}
            />
          </>
        )}
      </div>
    );
  }
}

export default connect((state) => ({ auth: state.auth }))(
  CustomerPaymentRequest
);
